<app-warranty-general-inputs  (partSelected)="partSelected($event)" (bicycleSelected)="bicycleSelected($event)" [tabSelected]="tabSelected" [type]="'batterycallback'" [currentArticle]="currentArticle" [formGroup]="formGroup">
</app-warranty-general-inputs>
<div class="mb-3 row">
  <label class="col-md-4 control-label text-start">{{(formGroup.get("batteryKind").value === "motor" ? "MOTOR" : 'BATTERY')|translate}} {{'SERIALNO'|translate|lowercase}} *</label>
  <div class="col-md-6" [formGroup]="formGroup">
    <input type="text" class="form-control" formControlName="serialNumber" maxlength="11">
  </div>
</div>
